/** Expense vocabulary shared by the model, validation and UI. */
import { APPLIED_ACCOUNTING_RULES } from "./payment";

export const EXPENSE_STATUSES = ["draft", "confirmed", "void"] as const;
export type ExpenseStatus = (typeof EXPENSE_STATUSES)[number];

export const EXPENSE_SOURCES = ["manual", "receipt", "screenshot", "excel_import"] as const;
export type ExpenseSource = (typeof EXPENSE_SOURCES)[number];

/** Applied rules plus `legacy` for rows imported from Excel, whose month comes from the `Mese` column. */
export const EXPENSE_ACCOUNTING_RULES = [...APPLIED_ACCOUNTING_RULES, "legacy"] as const;
export type ExpenseAccountingRule = (typeof EXPENSE_ACCOUNTING_RULES)[number];

/** Where the category came from; precedence user > merchant_rule > merchant_history. */
export const CATEGORY_SOURCES = ["user", "merchant_rule", "merchant_history", "legacy"] as const;
export type CategorySource = (typeof CATEGORY_SOURCES)[number];

/**
 * Excel sync state of a record (manual sync-file workflow, v1):
 * not_queued: draft, or a row that came from Excel · pending: must be written to the workbook
 * exported: included in a sync package, not yet acknowledged · synced: written to Excel at `syncedVersion`
 * failed: the Excel helper reported an error · blocked: needs user action (e.g. no workbook for that year)
 */
export const SYNC_STATUSES = ["not_queued", "pending", "exported", "synced", "failed", "blocked"] as const;
export type SyncStatus = (typeof SYNC_STATUSES)[number];
